import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';



const TipsTools = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();


    return ( 
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>
            
            <div id="main" className='Common_warrent tipstool_sec'>
                <div id="maintable" style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                    <div style={{display: 'table-row'}}>
                    <div id="leftbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}} />
                    <div id="maincontainer" style={{display: 'table-cell', width: '100%'}}>
                        <div id="mainnav" className='first_table'>
                        <table style={{width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223'}}>
                            <tbody><tr>
                                <td width="20%" style={{textAlign: 'left', visibility: 'hidden'}}>
                                <table className="hasprev hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td width="33px"><div className="prev left" /></td>
                                        <td>
                                        <div className="prevlbl left">
                                            <div className="prevtitle " style={{textAlign: 'left'}} />
                                            <div className="prevname " style={{textAlign: 'left'}}>Risk Matrix</div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                </td>
                                <td width="60%" style={{textAlign: 'center'}}>
                                <div id="pagetitlediv" style={{width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto'}}>
                                    <div id="ptitle" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px'}}>How to select a Warrant?</div>
                                    <div id="pname" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px'}}>Tips and Tools</div>
                                </div>
                                </td>
                                <td width="20%" style={{textAlign: 'right', visibility: 'hidden'}}>
                                <table className="hasnext  hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td>
                                        <div className="nextlbl right">
                                            <div className="nexttitle " style={{textAlign: 'right'}}>Next Topic</div>
                                            <div className="nextname " style={{textAlign: 'right'}}>Single share calls and puts at expiry</div>
                                        </div>
                                        </td>
                                        <td width="33px"><div className="next right" /></td>
                                    </tr>
                                    </tbody></table>
                                </td>
                            </tr>
                            </tbody></table>
                        </div>
                        <div id="maincontent" style={{marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px'}}>
                        <div id="mainscroll" style={{height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px'}}>
                            <div id="mainscrollcontent">
                            <style dangerouslySetInnerHTML={{__html: "\n            .txtbox{\n                max-width:60%;\n                margin:0 auto;\n                padding:1em;\n                background: rgb(56,56,56); /* Old browsers */\n                /* IE9 SVG, needs conditional override of 'filter' to 'none' */\n                background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzQ1NDg0ZCIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiMwMDAwMDAiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);\n                background: -moz-linear-gradient(top,  rgba(56,56,56,1) 0%, rgba(0,0,0,1) 100%); /* FF3.6-15 */\n                background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(56,56,56,1)), color-stop(100%,rgba(0,0,0,1))); /* Chrome4-9,Safari4-5 */\n                background: -webkit-linear-gradient(top,  rgba(56,56,56,1) 0%,rgba(0,0,0,1) 100%); /* Chrome10-25,Safari5.1-6 */\n                background: -o-linear-gradient(top,  rgba(56,56,56,1) 0%,rgba(0,0,0,1) 100%); /* Opera 11.10-11.50 */\n                background: -ms-linear-gradient(top,  rgba(56,56,56,1) 0%,rgba(0,0,0,1) 100%); /* IE10 preview */\n                background: linear-gradient(to bottom,  rgba(56,56,56,1) 0%,rgba(0,0,0,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n                filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#868686', endColorstr='#000000',GradientType=0 ); /* IE6-8 */\n            }\n            .txtbox h2,\n            .txtbox p{\n                text-align: left;\n                margin-bottom: 0;\n                margin-top: 0;\n            }\n        " }} />
                            <div className="contentbox">
                                <p>Malaysiawarrants.com.my has a selection of very useful tools that will assist in your warrant selection process and also in your subsequent decision on when to sell. Here are a brief summary of some of these: </p>
                                <div className="txtbox" style={{maxWidth: '60%'}}>
                                <h2>Warrant search</h2>
                                <p>Allows you to search for warrants by specifying your criteria, it will display all of the important info you need to make your decisions. <Link to="/tools/warrantsearch" target="_blank">Click here</Link></p>
                                </div>
                                <div className="txtbox" style={{maxWidth: '60%'}}>
                                <h2>Warrant terms</h2>
                                <p>Lists all of the current pricing information for a particular warrant. Can be accessed directly or via clicking on a warrant code in the warrant search table. <Link to="/tools/warrantterms" target="_blank">Click here</Link></p>
                                </div>
                                <div className="txtbox" style={{maxWidth: '60%'}}>
                                <h2>Compare warrants</h2>
                                <p>Allows you to select two warrants and compare their details side by side. <Link to="/tools/warrantcomparison" target="_blank">Click here</Link></p>
                                </div>
                                <div className="txtbox" style={{maxWidth: '60%'}}>
                                <h2>Money flow</h2>
                                <p>Will allow you to see which underlyings other investors have been buying and selling warrants over, giving you a feel for the market ‘flows’. <Link to="/marketdata/moneyflow" target="_blank">Click here</Link></p>
                                </div>
                                <div className="txtbox" style={{maxWidth: '60%'}}>
                                <h2>Warrant calculator</h2>
                                <p>Allows you to change the variables of a warrant and see the resultant effect on the warrant price. <Link to="/tools/warrantcalculator" target="_blank">Click here</Link></p>
                                </div>
                                
                            </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                        </div>
                        </div>
                    </div>
                    <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                    </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
                >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                    display: "table",
                    width: "100%",
                    textAlign: "center",
                    color: "#8F8F8F",
                    fontSize: "11px",
                    lineHeight: "40px",
                    }}
                >
                <div className='copyright_sec'>
                    Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                    reserved.
                </div>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    right: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasnext"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td>
                            <div className="nextlbl right">
                            <div
                                className="nextname "
                                style={{ textAlign: "right", fontSize: "15px" }}
                            >
                            <Link to="/edu/single-share-calls">
                        <span className="prevname ">Single share calls and puts at expiry</span>
                      </Link>
                            </div>
                            </div>
                        </td>
                        <td width="33px">
                        <Link to="/edu/single-share-calls">
                            <div className="next right" />
                            </Link>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    left: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasprev"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td width="33px">
                        <Link to="/edu/select-warrant/risk-matrix">
                            <div className="prev left" />
                            </Link>
                        </td>
                        <td>
                            <div className="prevlbl left">
                            <div
                                className="prevname "
                                style={{ textAlign: "left", fontSize: "15px" }}
                            >
                               <Link to="/edu/select-warrant/risk-matrix">
                        <span className="prevname ">Risk Matrix</span>
                      </Link>
                            </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
            {/* <div className="dbtn dbtn-seminarbtn">
            <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
        </div> */}

        <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
      );
}
export default TipsTools;